import type { ReactNode } from 'react';
import { createContext } from 'react';

import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { ContextPanelPlugin } from '@atlaskit/editor-plugin-context-panel';

export type Item = {
	itemName: string;
	component: ReactNode;
	closeLabel: string;
	closeAutoFocus?: boolean;
	close: () => void;
};

export type EditorContextPanelContextValue = {
	item: Item | null;
	setItem: (item: Item) => void;
	removeItem: (itemName: string) => void;
	editorAPI: PublicPluginAPI<[ContextPanelPlugin]> | null | undefined;
};

export const EditorContextPanelContext = createContext<EditorContextPanelContextValue>({
	item: null,
	setItem: () => {},
	removeItem: () => {},
	editorAPI: undefined,
});
